import component from './UiHelper.vue'
export default component
